import { render } from "./Cronjobs.vue?vue&type=template&id=342339a0"
import script from "./Cronjobs.vue?vue&type=script&lang=js"
export * from "./Cronjobs.vue?vue&type=script&lang=js"

import "./Cronjobs.vue?vue&type=style&index=0&id=342339a0&lang=scss"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QCard,QCardSection,QTable,QTd});
